import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ViewMode } from './viewMode'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ViewerManagerViewModeApi } from './viewerManagerViewModeApi'
import { DSViewModeAPISymbol, IAppWillMountHandler, IPageWillMountHandler, LifeCycle } from '@wix/thunderbolt-symbols'
import { mobileClassUpdater } from './mobileClassUpdater'
import { ComponentsRegistrarSymbol } from '@wix/thunderbolt-components-loader'
import { ComponentsRegistrar } from './componentsRegistrar'

export const editor: ContainerModuleLoader = (bind) => {
	bind(DSViewModeAPISymbol).to(ViewMode)
	bind(ViewerManagerApiImplementor).to(ViewerManagerViewModeApi)
	bind(ComponentsRegistrarSymbol).to(ComponentsRegistrar)
	bind<IAppWillMountHandler>(LifeCycle.AppWillMountHandler).to(mobileClassUpdater)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind<IPageWillMountHandler>(LifeCycle.PageWillMountHandler).to(mobileClassUpdater)
}
